import { cn } from './cn.js';

import type { ReactElement, ReactNode } from 'react';

interface Tab {
  id: string;
  label: string;
  count?: number;
}

interface GlassTabsProps {
  tabs: readonly Tab[];
  activeTab: string;
  onTabChange: (id: string) => void;
}

export function GlassTabs({ tabs, activeTab, onTabChange }: GlassTabsProps): ReactElement {
  return (
    <div className="flex w-full bg-surface-raised rounded-lg p-1 gap-1 border border-border">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={(): void => {
            onTabChange(tab.id);
          }}
          className={cn(
            'flex-1 px-4 py-2 text-sm font-medium rounded-md transition-all cursor-pointer',
            activeTab === tab.id
              ? 'bg-primary text-white shadow-sm'
              : 'text-text-secondary hover:text-text hover:bg-bg-muted',
          )}
        >
          <span className="flex items-center justify-center gap-2">
            {tab.label}
            {tab.count !== undefined && (
              <span
                className={cn(
                  'text-[11px] px-1.5 py-0.5 rounded-full font-medium leading-none',
                  activeTab === tab.id
                    ? 'bg-white/20 text-white'
                    : 'bg-bg-muted text-text-tertiary',
                )}
              >
                {String(tab.count)}
              </span>
            )}
          </span>
        </button>
      ))}
    </div>
  );
}

interface GlassTabPanelProps {
  children: ReactNode;
  className?: string;
}

export function GlassTabPanel({ children, className }: GlassTabPanelProps): ReactElement {
  return <div className={cn('pt-5', className)}>{children}</div>;
}
